<template>
  <ContentPage>
    <template #header>
      <content-page-title>
        Billing
      </content-page-title>
    </template>

    <div class="d-flex flex-column align-stretch flex-grow-0" style="height: 100%;"> 

      <div>
        <BillingTabs />
      </div>
      
      <router-view />
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage, ContentPageTitle } from '@/components/pages'
import BillingTabs from './BillingTabs'

export default {
  components: { BillingTabs, ContentPage, ContentPageTitle }

}
</script>